import { FuseNavigation } from '@fuse/types';
import { CompanySubset } from 'app/api/company.api.service';

export const defaultNavigation: FuseNavigation[] = [
    {
        id: 'general',
        title: 'General',
        type: 'group',
        children: [
            {
                id: 'dashboard',
                title: 'Tableau de bord',
                type: 'item',
                icon: 'dashboard',
                url: '/dashboard',
            },
/*            {
                id: 'pcg',
                title: 'Plan Comptable Général',
                type: 'item',
                icon: 'domain',
                url: '/pcg',
            },*/
        ],
    },
];

export const navigationByCompany = (company: CompanySubset): FuseNavigation => {
    return {
        id: company.id,
        title: company.name,
        type: 'group',
        children: [
            // {
            //     id: 'home',
            //     title: 'Accueil',
            //     type: 'item',
            //     icon: 'warning', // home
            //     url: `#`,
            // },
/*            {
                id: 'company',
                title: 'Société',
                type: 'item',
                icon: 'business',
                url: `/company/${company.id}`,
            },*/
            {
                id: 'pl',
                title: 'P&L',
                type: 'item',
                icon: 'account_balance',
                url: `/pl/${company.id}`,
            },
            {
                id: 'analysis',
                title: 'Analyse / Visualisation',
                type: 'collapsable',
                icon: 'grid_on',
                children: [
                    {
                        id: 'cube',
                        title: 'Cube',
                        type: 'item',
                        icon: 'account_balance',
                        url: `/cube/${company.id}/grid`,
                    },
                    {
                        id: 'h-resultat',
                        title: 'Résultat',
                        type: 'item',
                        icon: 'account_balance',
                        url: `/cube/${company.id}/resultat`,
                    },
                    {
                        id: 'h-revenue',
                        title: 'Chiffre d\'affaires',
                        type: 'item',
                        icon: 'account_balance',
                        url: `/cube/${company.id}/revenue`,
                    },
                    {
                        id: 'h-revenue-by-category',
                        title: 'CA par Catégorie',
                        type: 'item',
                        icon: 'account_balance',
                        url: `/cube/${company.id}/revenue-by-category`,
                    },
                    {
                        id: 'h-expenses',
                        title: 'Charges',
                        type: 'item',
                        icon: 'account_balance',
                        url: `/cube/${company.id}/expenses`,
                    },
                    {
                        id: 'h-expenses-by-category',
                        title: 'Charges par Catégorie',
                        type: 'item',
                        icon: 'account_balance',
                        url: `/cube/${company.id}/expenses-by-category`,
                    },
                    {
                        id: 'h-equity',
                        title: 'Capitaux',
                        type: 'item',
                        icon: 'account_balance',
                        url: `/cube/${company.id}/equity`,
                    },
                    {
                        id: 'h-invest',
                        title: 'Invest',
                        type: 'item',
                        icon: 'account_balance',
                        url: `/cube/${company.id}/invest`,
                    },
                    {
                        id: 'h-banks',
                        title: 'Banques',
                        type: 'item',
                        icon: 'account_balance',
                        url: `/cube/${company.id}/banks`,
                    },
                    {
                        id: 'h-cash-burn',
                        title: 'Cash Burn',
                        type: 'item',
                        icon: 'warning',
                        hidden: true,
                        url: `/cube/${company.id}/cash-burn`,
                    },
                    {
                        id: 'h-third-party',
                        title: 'Tiers',
                        type: 'item',
                        icon: 'account_balance',
                        url: `/cube/${company.id}/third-party`,
                    },
                    {
                        id: 'h-third-party-2',
                        title: 'Tiers 2',
                        type: 'item',
                        icon: 'account_balance',
                        url: `/cube/${company.id}/third-party-2`,
                    },
                ],
            },
            {
                id: 'charts',
                title: 'Graphiques',
                type: 'collapsable',
                icon: 'bar_chart',
                children: [
                    {
                        id: 'chart-revenue',
                        title: 'Chiffre d\'affaires',
                        type: 'item',
                        icon: 'bar_chart',
                        url: `/charts/${company.id}/revenue`,
                    },
                    {
                        id: 'chart-revenue-by-category',
                        title: 'CA par Catégorie',
                        type: 'item',
                        icon: 'bar_chart',
                        url: `/charts/${company.id}/revenue-by-category`,
                    },
                    {
                        id: 'chart-expenses',
                        title: 'Charges',
                        type: 'item',
                        icon: 'bar_chart',
                        url: `/charts/${company.id}/expenses`,
                    },
                    {
                        id: 'chart-expenses-by-category',
                        title: 'Charges par Catégorie',
                        type: 'item',
                        icon: 'bar_chart',
                        url: `/charts/${company.id}/expenses-by-category`,
                    },
                ],
            },
            {
                id: 'comptab',
                title: 'Comptabilité',
                type: 'collapsable',
                icon: 'bar_chart',
                children: [
                    {
                        id: 'grand-livre',
                        title: 'Grand Livre',
                        type: 'item',
                        icon: 'grid_on',
                        url: `/accounting/${company.id}`,
                    },
                    // {
                    //     id: 'balance',
                    //     title: 'Balance',
                    //     type: 'item',
                    //     icon: 'bar_chart',
                    //     url: ``,
                    // },
                ],
            },   
            {
                id: 'payroll',
                title: 'Paye',
                type: 'item',
                icon: 'people',
                url: `/payroll/${company.id}`,
            },            
            {
                id: 'cadrage',
                title: 'Variables Société',
                type: 'collapsable',
                icon: 'grid_on',
                children: [
                    // {
                    //     id: 'accounting',
                    //     title: 'Comptabilité',
                    //     type: 'item',
                    //     icon: 'grid_on',
                    //     url: `/accounting/${company.id}`,
                    // },                 
                    {
                        id: 'journal',
                        title: 'Journal',
                        type: 'item',
                        icon: 'grid_on',
                        url: `/journal/${company.id}`,
                    },
                    {
                        id: 'plan',
                        title: 'Plan Comptable',
                        type: 'item',
                        icon: 'grid_on',
                        url: `/plan/${company.id}`,
                    },
                    {
                        id: 'analytics',
                        title: 'Analytics',
                        type: 'item',
                        icon: 'grid_on',
                        url: `/analytics/${company.id}`,
                    },
                    {
                        id: 'customers',
                        title: 'Clients',
                        type: 'item',
                        icon: 'grid_on',
                        url: `/customers/${company.id}`,
                    },
                    {
                        id: 'providers',
                        title: 'Fournisseurs',
                        type: 'item',
                        icon: 'grid_on',
                        url: `/providers/${company.id}`,
                    },
                ],
            },
        ],
    };
};
